// client/src/components/Events.js
import React, { useRef, useState, useEffect } from 'react';
import './Events.css';

const upcomingEvents = [
  {
    date: { month: 'JAN', day: '25–26', year: '2027' },
    fullDate: 'January 25–26, 2027',
    title: 'International Conference on Medical and Health Sciences (ICMHS)',
    location: 'Dar es Salaam',
    targetProfile:
      'Academic clinicians, research laboratory networks, and hospital directors. An excellent opportunity to pitch specialized laboratory testing rigs.',
    details: 'Track via All Conference Alert Medical Listings.',
  },
  {
    date: { month: 'MAR', day: '04', year: '2027' },
    fullDate: 'March 4, 2027',
    title: 'International Conference on Optical Technologies for Healthcare & Wellness (ICOTHWA)',
    location: 'Morogoro',
    targetProfile:
      'Medical imaging technicians, laboratory diagnostic specialists, and biomedical engineers.',
    details: 'Verified via Conference Alerts India.',
  },
  {
    date: { month: 'MAR', day: '04–05', year: '2027' },
    fullDate: 'March 4–5, 2027',
    title: 'International Conference on Advances in Medicine and Health Sciences (ICAMHS)',
    location: 'Zanzibar',
    targetProfile:
      'Regional public health delegates and clinical procurement teams evaluating international medical equipment providers.',
    details: 'Verified via International Conference Alerts.',
  },
  {
    date: { month: 'JUN', day: '22–25', year: '2027' },
    fullDate: 'June 22–25, 2027',
    title: 'Congress of the African Association of Nephrology (AFRAN) & NESOT Conference',
    location: 'Dar es Salaam',
    targetProfile:
      'Intensive care specialists, urologists, and renal department heads. Highly lucrative for specialized diagnostic kits and chemical fluid analyzers.',
    details: 'Track via the African Association of Nephrology Official Hub.',
  },
  {
    date: { month: 'AUG', day: '2027', year: 'Provisional' },
    fullDate: 'August 2027 (Provisional Calendar Cycle)',
    title: 'Pharmatech & Medical & Lab East Africa Exhibition',
    location: 'Diamond Jubilee Hall, Dar es Salaam',
    targetProfile:
      'The largest dedicated medical equipment trade floor in Tanzania, heavily matching B2B distributors, medical warehouse managers, and bulk importers.',
    details: 'Verified in the official TanTrade Exhibitions Calendar.',
  },
  {
    date: { month: 'SEP', day: '2027', year: 'Provisional' },
    fullDate: 'September 2027 (Provisional Calendar Cycle)',
    title: 'MEDEXPO Tanzania',
    location: 'Diamond Jubilee Expo Centre, Dar es Salaam',
    targetProfile:
      'Wide-scale global medical manufacturing showcase targeting local hospital buyers, private clinical chains, and laboratory procurement agents.',
    details: 'Managed by Expogroup and listed via Lidya Fair Medexpo Guide.',
  },
  {
    date: { month: 'SEP', day: 'LATE', year: '2027' },
    fullDate: 'Expected late September 2027',
    title: 'MeLSAT Annual Scientific Conference & Exhibition',
    location: 'Rotates Annually (Check portal for 40th AGM city selection)',
    targetProfile:
      'The absolute highest priority event for laboratory technology. Attended by almost every major laboratory scientist, manager, and diagnostic decision-maker in the country.',
    details:
      'Official event portal managed by the Medical Laboratory Scientists Association of Tanzania.',
  },
  {
    date: { month: 'OCT', day: '2027', year: 'Annual' },
    fullDate: 'October 2027 (Annual Cycle)',
    title: 'Tanzania Health Summit (THS) & Medical Expo',
    location: 'Mlimani City Conference Centre, Dar es Salaam',
    targetProfile:
      'Backed by the Ministry of Health, drawing over 1,000+ top-tier healthcare professionals, private hospital board members, and government policymakers.',
    details: 'Event updates published directly on the Tanzania Health Summit Hub.',
  },
];

const partners = [
  { name: 'Partner Logo 1', logoUrl: '/images/partners/logo1.png' },
  { name: 'Partner Logo 2', logoUrl: '/images/partners/logo2.png' },
  { name: 'Partner Logo 3', logoUrl: '/images/partners/logo3.png' },
  { name: 'Partner Logo 4', logoUrl: '/images/partners/logo4.png' },
  { name: 'Partner Logo 5', logoUrl: '/images/partners/logo5.png' },
  { name: 'Partner Logo 6', logoUrl: '/images/partners/logo6.png' },
  { name: 'Partner Logo 7', logoUrl: '/images/partners/logo7.png' },
  { name: 'Partner Logo 8', logoUrl: '/images/partners/logo8.png' },
  { name: 'Partner Logo 9', logoUrl: '/images/partners/logo9.png' },
  { name: 'Partner Logo 10', logoUrl: '/images/partners/logo10.jpg' },
];

const Events = () => {
  const trackRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [viewMode, setViewMode] = useState('carousel'); // 'carousel' | 'grid'

  // Auto-glide the floating carousel gently unless hovered or in grid mode
  useEffect(() => {
    if (viewMode !== 'carousel' || isPaused) return;
    const el = trackRef.current;
    if (!el) return;

    const interval = setInterval(() => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;

      // Scroll by one card width (~400px), loop smoothly back to start when reaching end
      if (el.scrollLeft >= maxScroll - 20) {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        el.scrollBy({ left: 400, behavior: 'smooth' });
      }
    }, 4800);

    return () => clearInterval(interval);
  }, [viewMode, isPaused]);

  const scrollEvents = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    const scrollAmount = direction === 'left' ? -410 : 410;
    el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  return (
    <section className="events-partners-section">
      {/* --- Upcoming Events Section --- */}
      <div className="events-container">
        <div className="events-header-bar">
          <div className="events-title-group">
            <span className="events-schedule-pill">
              <i className="far fa-calendar-alt"></i> Chronological Event Schedule (2026–2027)
            </span>
            <h2 className="section-title events-main-title">News & Upcoming Events</h2>
          </div>

          <div className="events-controls">
            <div className="events-view-toggle" role="group" aria-label="Events layout mode">
              <button
                type="button"
                className={`view-mode-btn ${viewMode === 'carousel' ? 'active' : ''}`}
                onClick={() => setViewMode('carousel')}
                title="Floating Carousel View"
              >
                <i className="fas fa-stream"></i>
                <span>Floating Slide</span>
              </button>
              <button
                type="button"
                className={`view-mode-btn ${viewMode === 'grid' ? 'active' : ''}`}
                onClick={() => setViewMode('grid')}
                title="Full Schedule Grid View"
              >
                <i className="fas fa-th-large"></i>
                <span>View All ({upcomingEvents.length})</span>
              </button>
            </div>

            {viewMode === 'carousel' && (
              <div className="events-nav-arrows">
                <button
                  type="button"
                  className="event-arrow-btn"
                  onClick={() => scrollEvents('left')}
                  aria-label="Previous events"
                >
                  <i className="fas fa-chevron-left"></i>
                </button>
                <button
                  type="button"
                  className="event-arrow-btn"
                  onClick={() => scrollEvents('right')}
                  aria-label="Next events"
                >
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            )}
          </div>
        </div>

        <div
          ref={trackRef}
          className={viewMode === 'carousel' ? 'events-floating-carousel' : 'events-grid'}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={() => setIsPaused(true)}
          onTouchEnd={() => setIsPaused(false)}
        >
          {upcomingEvents.map((event, index) => (
            <article key={index} className="event-card">
              <div className="event-card-top">
                <div className="event-date">
                  <span className="month">{event.date.month}</span>
                  <span className="day">{event.date.day}</span>
                  <span className="year">{event.date.year}</span>
                </div>

                <div className="event-details">
                  <h3 className="event-title">{event.title}</h3>
                  <p className="event-date-exact">
                    <i className="far fa-clock"></i> {event.fullDate}
                  </p>
                  <p className="event-location">
                    <i className="fas fa-map-marker-alt"></i> {event.location}
                  </p>
                </div>
              </div>

              <div className="event-card-body">
                <p className="event-profile">
                  <strong>Target Profile:</strong> {event.targetProfile}
                </p>
                <p className="event-meta-details">
                  <i className="fas fa-info-circle"></i> <span>{event.details}</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* --- Partners Section --- */}
      <div className="partners-container">
        <h3 className="partners-title">Our Trusted Partners & Brands</h3>
        <div className="logo-scroller">
          <div className="logo-track">
            {partners.map((partner, index) => (
              <div key={`partner-a-${index}`} className="partner-logo">
                <img src={partner.logoUrl} alt={partner.name} />
              </div>
            ))}
            {partners.map((partner, index) => (
              <div key={`partner-b-${index}`} className="partner-logo">
                <img src={partner.logoUrl} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;
